export default __webpack_public_path__ + "static/media/pexels-tima-miroshnichenko-6860500.68e72b70.jpg";